import { CommonModule } from "@angular/common";
import { NgModule, Type } from "@angular/core";
import { CoreContentModule } from "@obg/ngx.core.content";
import { CoreUiModule } from "@obg/ngx.ui.core";

import { ContentContainer } from "./content.container";

const DIRECTIVES: Type<unknown>[] = [ContentContainer];

@NgModule({
	imports: [CommonModule, CoreUiModule, CoreContentModule],
	exports: DIRECTIVES,
	declarations: DIRECTIVES,
})
export class ContentUIModule {}
